import { ContactInfo } from "src/types/listing";
import ContactCard, { ContactCardProps, LayoutType } from "../common/ContactCard";
import SectionHeader from "./SectionHeader";
export default function PhoneNumbers({
  contacts,
  ContactCardProps = {},
}: {
  contacts: ContactInfo[];
  ContactCardProps?: Partial<ContactCardProps>;
}) {
  const { layoutType } = ContactCardProps;
  return (
    <div className="phone-numbers max-w-[729px]">
      <SectionHeader title="Phone Numbers" />
      <div className={`grid gap-4 ${layoutType !== LayoutType.horizontal ? "md:grid-cols-4 grid-cols-2" : "grid-cols-1"}`}>
        {contacts?.map((contact) => (
          <ContactCard
            key={`contact-card-${contact.id}`}
            contact={contact}
            {...ContactCardProps}
          />
        ))}
      </div>
    </div>
  );
}
